import React from "react";
import { toast } from "react-toastify";

export function toastSuccess(body: React.ReactNode) {
  toast.success(body, {
    className: "toast toast-success",
  });
}

export function toastError(body: React.ReactNode) {
  toast.error(body, {
    className: "toast toast-error",
  });
}

export function toastWarning(body: React.ReactNode) {
  toast.error(body, {
    className: "toast toast-warning",
  });
}

// Neutral "FYI" toast — use when the operator's action was a no-op (e.g. "nothing to approve")
// and the system needs to acknowledge the click without colouring it as success or error.
export function toastInfo(body: React.ReactNode) {
  toast.info(body, {
    className: "toast toast-info",
  });
}
